const isFilterActive = (val, typeahead) => {
  if (!val && !typeahead) return "bg-white text-secondary";
  if (!val && !!typeahead) return "text-secondary";
  if (!!val && !!typeahead) return "active-filter bg-primary bg-opacity-10";
  return "bg-primary text-primary bg-opacity-10 shadow-none border border-primary";
};

export default isFilterActive;
